export const LOAD_SUBSCRIBED_MAPPINGS: string = 'LOAD_SUBSCRIBED_MAPPINGS';
export const SUBSCRIBE_MODEL_API_REQUEST: string = 'SUBSCRIBE_MODEL_API_REQUEST';
export const ADD_SUBSCRIPTION_STORE_MAPPING: string = 'ADD_SUBSCRIPTION_STORE_MAPPING';
export const UNSUBSCRIBE_MODEL_API_REQUEST: string = 'UNSUBSCRIBE_MODEL_API_REQUEST';
export const REMOVE_SUBSCRIPTION_STORE_MAPPING: string = 'REMOVE_SUBSCRIPTION_STORE_MAPPING';

export interface LoadSubscribedMappings {
	readonly type: 'LOAD_SUBSCRIBED_MAPPINGS';
	readonly subscribedPortfolioMapping: Map<string, string>;
}

export interface SubscribeModelApiRequest {
	readonly type: 'SUBSCRIBE_MODEL_API_REQUEST';
	readonly portfolioId: string;
	readonly origin: string;
}

export interface AddSubscriptionStoreMapping {
	readonly type: 'ADD_SUBSCRIPTION_STORE_MAPPING';
	readonly newMapping: Map<string, string>;
}

export interface UnsubscribeModelApiRequest {
	readonly type: 'UNSUBSCRIBE_MODEL_API_REQUEST';
	readonly portfolioId: string;
}

export interface RemoveSubscriptionStoreMapping {
	readonly type: 'REMOVE_SUBSCRIPTION_STORE_MAPPING';
	readonly portfolioId: string;
}

export type SubscribedModelPortfoliosAction =
	| LoadSubscribedMappings
	| SubscribeModelApiRequest
	| AddSubscriptionStoreMapping
	| UnsubscribeModelApiRequest
	| RemoveSubscriptionStoreMapping;
